import { platform } from 'constants'
import { UPSPACE_FULL_PATH } from 'constants/externalLinks'
import { useTheme } from 'contexts'
import isUAWebView from 'is-ua-webview'
import React, { useEffect, useState } from 'react'
import { Text as RNText, StyleSheet } from 'react-native'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { LoadingSpinner } from 'widgets/LoadingSpinner'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'

import { useAuth } from 'hooks/useAuth'

const styles = StyleSheet.create({
  pressable: { flex: 1 },
  text: {
    color: 'white',
    fontSize: 17,
    paddingVertical: 8,
  },
  longPressText: {
    fontSize: 14,
    fontWeight: 'bold',
  },
})

export const GoogleLoginButton = () => {
  const { login } = useAuth()
  const theme = useTheme()

  const isLoading = login?.google?.isLoading

  const [isWebView, setIsWebView] = useState(false)
  const [isSafariBrowser, setIsSafariBrowser] = useState(false)

  const setBrowsers = () => {
    if (platform.IS_WEB) {
      const ua = navigator.userAgent || navigator.vendor
      const isWebViewBrowser = platform.IS_WEB && ua && isUAWebView(ua)
      setIsWebView(isWebViewBrowser || false)
      const isSafari = platform.IS_WEB && ua?.indexOf('AppleWebKit') > -1
      setIsSafariBrowser(isSafari)
    }
  }

  useEffect(() => {
    setBrowsers()
  }, [])

  return (
    <Pressable style={styles.pressable} onPress={() => login.google.mutate()}>
      <Box
        height={50}
        border={{ color: isWebView ? 'black' : 'v2primary', width: isWebView ? 0 : 2 }}
        borderRadius='sm'
        flexDirection='row'
        justifyContent='center'
        align='center'
        backgroundColor={isWebView ? 'black' : 'transparent'}
      >
        {isLoading && <LoadingSpinner size='small' />}
        {!isLoading && (
          <>
            <Icon name='google' color={isWebView ? 'v2primary' : 'white'} />
            <Box width={10} />
            <Text
              color={isWebView ? 'greyDark' : 'v2primary'}
              fontWeight={isWebView ? 'bold' : 'normal'}
              fontSize={isWebView ? 'sm' : 'md'}
            >
              Sign In with Google{isWebView && '? '}
            </Text>
            {isWebView && isSafariBrowser && (
              <RNText
                accessibilityRole='link'
                href={UPSPACE_FULL_PATH}
                hrefAttrs={{ rel: 'noreferrer', download: true, target: '_blank' }}
                style={[styles.longPressText, { color: theme.colors.v2primary }]}
              >
                Long Press Here
              </RNText>
            )}
          </>
        )}
      </Box>
    </Pressable>
  )
}
